var Owlvatar = require("components/avatars/Owlvatar");
var HouseModal = require("components/games/HouseModal");

class HouseAvatar extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
		};
	}

	getConstraints(maxWidth, maxHeight) {
		var constraints = {};
		if (maxWidth) { constraints.width = (maxWidth + "px") };
		if (maxHeight) { constraints.height = (maxHeight + "px") };
		constraints.cursor = "pointer"
		return constraints;
	}
	showInterior() {
		this.refs.houseModal.show();
	}
	render() {
		var student = this.props.student;
		var imagePath = require("perks/houses/" + this.props.student.perks.houses.toLowerCase().replace(/ /g, "-").replace("'","") + ".png");
		var constraints = this.getConstraints(this.props.maxWidth, this.props.maxHeight)

		var houseModal = (
			<HouseModal ref="houseModal" student={ student } 
				currentStudent={ this.props.currentStudent } />
		);

		return (
			<div>
				<img src={ imagePath } onClick={ this.showInterior } className="owlHouse" style={ constraints } />
				{ houseModal }
			</div>
		)
	}
};

HouseAvatar.propTypes = StrictPropTypes({
	// Data on the student
	student: PropTypes.object.isRequired,

	// Data on a visiting student
	currentStudent: PropTypes.object,

	// Capped dimensions
	maxWidth: PropTypes.number,
	maxHeight: PropTypes.number
});

module.exports = HouseAvatar;


// WEBPACK FOOTER //
// ./modules/components/avatars/HouseAvatar.js